var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-center",attrs:{"small":"","text":""},on:{"click":_vm.onClick}},[_vm._t("default"),_c('div',{ref:"printFrame",attrs:{"id":"printFrame"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }